
export default {

  //Round everything up. Ex: 2.1 => 3
  specialRoundUp(num) {
    var factor = Math.pow(10, Math.floor(Math.log(num) / Math.LN10));
    return factor * Math.ceil(num / factor);
  },

  calculateNumberOfPages(total, numberPerPage) {
    let modulo = total % numberPerPage;
    let result = Math.floor(total / numberPerPage);

    if (modulo > 0) {
      return result + 1;
    }
    return result;
  }

}



// WEBPACK FOOTER //
// ./src/plugins/utilities.js